<template>
    <nav class="bg-inherit border-gray-200">
        <div class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
            <a href="#" class="flex items-center space-x-3 rtl:space-x-reverse">
                <img src="../assets/company_logo/Airprove-white_logo-NOBG.png" class="w-16 h-16" alt="AirProve Logo" />
                <span class="self-center text-2xl text-white font-semibold whitespace-nowrap">AirProve</span>
            </a>
        </div>
    </nav>
</template>